import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { createAsyncStoragePersistor } from 'react-query/createAsyncStoragePersistor-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { getPersistStorageInstance } from './persistStorage';

class QueryPersistCacheInstance {
    private static instance: QueryPersistCacheInstance | null = null;

    private readonly persistor:
        | ReturnType<typeof createAsyncStoragePersistor>
        | ReturnType<typeof createWebStoragePersistor>;

    private constructor(queryKeys: (QUERY_KEYS | string | string[])[], throttleTime?: number) {
        this.persistor = getPersistStorageInstance(queryKeys, throttleTime);
    }

    public static init(queryKeys: (QUERY_KEYS | string | string[])[], throttleTime?: number): void {
        QueryPersistCacheInstance.instance = new QueryPersistCacheInstance(queryKeys, throttleTime);
    }

    public static getInstance(): QueryPersistCacheInstance | null {
        return QueryPersistCacheInstance.instance;
    }

    public getPersistor() {
        return this.persistor;
    }
}

export default QueryPersistCacheInstance;
